<template>
    <modal height="auto" width="80%" :scrollable="true" name="calendar-leisure-time" classes="modal_default" :clickToClose="true"  @before-open="beforeOpen">
    <div class="card" data-testid="calendar-leisure-dialog">
        <div class="card-header">
            Přehled volna
        </div>
        <div class="card-body" v-if="leisureTimePending">

        </div>
        <div class="card-body" v-else="">
            <div class="row" v-if="leisureTime.length > 0">
                <table class="table">
                    <thead>
                    <tr class="row m-0">
                        <th class="col-sm-2">datum</th>
                        <th class="col-sm-2">od - do</th>
                        <th class="col-sm-2">délka</th>
                        <th class="col-sm-6">poznámka</th>
                    </tr>
                    </thead>
                    <tbody>
                    <template v-for="lt in leisureTime">
                        <tr class="row m-0 text-left" :data-testid="'calendar-leisure-row-' + lt.id">
                            <td class="col-sm-2" v-if="editingId !== lt.id">{{ lt.valid }}</td>
                            <td class="col-sm-2" v-if="editingId !== lt.id">{{ lt.time_from }} - {{ lt.time_to }}</td>
                            <td class="col-sm-2" v-if="editingId !== lt.id">{{ lt.duration * 5 | minutesToCsTime }}</td>
                            <td class="col-sm-5" v-if="editingId !== lt.id">{{ lt.note }}</td>

                            <td class="col-sm-11" v-else="">
                                <form @submit.prevent="submitFormUpdateLeisureTime">
                                    <div class="input-group">
                                        <span class="input-group-addon">datum</span>
                                        <datepicker v-model="formLeisureTime.valid" placeholder="vybrat datum" format="dd.MM.yyyy" language="cs" :monday-first="true" :full-month-name="true" name="chooseDate" input-class="datapickerInput"></datepicker>
                                        <span class="input-group-addon">
                                                          Celý den:&nbsp;
                                            <input v-model="formLeisureTime.allDay" type="checkbox">
                                        </span>
                                        <span class="input-group-addon">od</span>
                                        <timepicker :minute-interval="10" format="H:mm" v-model="formLeisureTime.timeFrom" disabled></timepicker>
                                        <span class="input-group-addon">do</span>
                                        <timepicker :minute-interval="10" format="H:mm" v-model="formLeisureTime.timeTo" disabled></timepicker>
                                        <span class="input-group-addon">poznámka</span>
                                        <input v-model="formLeisureTime.note" type="text" class="form-control" id="leisureTimeNote" placeholder="poznámka">
                                        <button v-if="updatedLeisureTimePending === false && possibleToSave === true" type="submit" class="btn btn-primary">Uložit</button>
                                        <button v-else-if="updatedLeisureTimePending === false" type="submit" class="btn btn-primary disabled" disabled="disabled">Uložit</button>
                                        <button class="btn btn-primary disabled" disabled="disabled" v-else><i class="fa fa-spinner fa-pulse fa-fw"></i> Ukládám</button>
                                    </div>
                                </form>
                            </td>

                            <td class="col-sm-1 text-right">
                                <button class="btn btn-sm btn-danger" @click="deleteLeisureTime(lt.id)" v-if="editingId === false" :data-testid="'calendar-leisure-delete-' + lt.id"><i class="fa fa-trash" aria-hidden="true"></i></button>
                                <button class="btn btn-sm btn-danger disabled" v-else="" disabled="disabled"><i class="fa fa-trash" aria-hidden="true"></i></button>
                                <button class="btn btn-sm btn-secondary" @click="setEditingLeisureTime(lt)" v-if="editingId === lt.id"><i class="fa fa-times" aria-hidden="true"></i></button>
                                <button class="btn btn-sm btn-secondary" @click="setEditingLeisureTime(lt)" v-else-if="editingId === false" :data-testid="'calendar-leisure-edit-' + lt.id"><i class="fa fa-edit" aria-hidden="true"></i></button>
                                <button class="btn btn-sm btn-secondary disabled" disabled="disabled" v-else=""><i class="fa fa-edit" aria-hidden="true"></i></button>
                            </td>
                        </tr>
                    </template>
                    </tbody>
                </table>
            </div>
            <div class="row" v-if="editingId === false">
                <div class="form-group col-md-12">
                    <form @submit.prevent="submitFormAddLeisureTime" data-testid="calendar-leisure-add-form">
                        <div class="input-group">
                            <span class="input-group-addon">datum</span>
                            <datepicker v-model="formLeisureTime.valid" placeholder="vybrat datum" format="dd.MM.yyyy" language="cs" :monday-first="true" :full-month-name="true" name="chooseDate" input-class="datapickerInput"></datepicker>
                            <span class="input-group-addon">
                                                          Celý den:&nbsp;
                                        <input v-model="formLeisureTime.allDay" type="checkbox" data-testid="calendar-leisure-all-day">
                                        </span>
                            <span class="input-group-addon">od</span>
                            <timepicker :minute-interval="10" format="H:mm" v-model="formLeisureTime.timeFrom" disabled></timepicker>
                            <span class="input-group-addon">do</span>
                            <timepicker :minute-interval="10" format="H:mm" v-model="formLeisureTime.timeTo" disabled></timepicker>
                            <span class="input-group-addon">poznámka</span>
                            <input v-model="formLeisureTime.note" type="text" class="form-control" id="leisureTimeNote" placeholder="poznámka" data-testid="calendar-leisure-note">
                            <button v-if="newLeisureTimePending === false && possibleToSave === true" type="submit" class="btn btn-success" data-testid="calendar-leisure-add">Přidat</button>
                            <button v-else-if="newLeisureTimePending === false" type="submit" class="btn btn-success disabled" disabled="disabled">Přidat</button>
                            <button class="btn btn-success disabled" disabled="disabled" v-else><i class="fa fa-spinner fa-pulse fa-fw"></i> Ukládám</button>
                        </div>
                        <!--<small id="numberError" class="form-text text-danger text-left" v-if="updatedLeisureTimeError.number">{{ updatedLeisureTimeError.number.message }}</small>-->
                    </form>
                </div>
            </div>
            <!-- {{ $moment(updatedLeisureTime.valid ).format('L') }} - window: {{ ((timeFrom.H%24) * 4) + (timeFrom.mm / 15) }} - duration: {{ (((timeTo.H%24) * 4) + (timeTo.mm / 15)) - (((timeFrom.H%24) * 4) + (timeFrom.mm / 15)) }} - ponámka {{ updatedLeisureTime.note }}
            {{ timeFrom.H }} <br>
            {{ ((timeFrom.H%24) * 4) + (timeFrom.mm / 15) }}
            {{ formLeisureTime }} -->
        </div>
    </div>
    </modal>
</template>

<script>
  import apiMixin from '@/mixins'

  export default {
    data () {
      return {
        leisureTime: null,
        leisureTimePending: true,
        leisureTimeError: false,
        newLeisureTime: {},
        newLeisureTimeError: false,
        newLeisureTimePending: false,
        newLeisureTimeDone: false,
        updatedLeisureTime: {},
        originalLeisureTime: {},
        formLeisureTime: {
          id: null,
          timeFrom: {
            H: '',
            mm: ''
          },
          timeTo: {
            H: '',
            mm: ''
          },
          valid: null,
          note: '',
          allDay: false
        },
        updatedLeisureTimeError: false,
        updatedLeisureTimePending: false,
        updatedLeisureTimeDone: false,
        deleteLeisureTimeError: false,
        deleteLeisureTimePending: false,
        deleteLeisureTimeDone: false,
        editingId: false
        // Update form
      }
    },
    props: ['opened', 'doctorId'],
    mixins: [apiMixin],
    methods: {
      beforeOpen () {
        console.log('oteviram modalko' + this.doctorId)
        this.getDoctorsLeisureTime(this.doctorId)
      },
      setEditingLeisureTime (leisureTime) {
        if (this.editingId === false) {
          this.formLeisureTime.valid = this.$moment(leisureTime.valid, 'D.M.YYYY').toDate()
          console.log(typeof this.calculateHourFromWindow(leisureTime.time_window) + ':' + typeof this.calculateMinuteFromWindow(leisureTime.time_window) + '--' + typeof this.calculateHourFromWindow(leisureTime.time_window + leisureTime.duration) + ':' + typeof this.calculateMinuteFromWindow(leisureTime.time_window + leisureTime.duration))
          console.log(this.calculateHourFromWindow(leisureTime.time_window) + ':' + this.calculateMinuteFromWindow(leisureTime.time_window) + '--' + this.calculateHourFromWindow(leisureTime.time_window + leisureTime.duration) + ':' + this.calculateMinuteFromWindow(leisureTime.time_window + leisureTime.duration))
          this.formLeisureTime.timeFrom.H = this.calculateHourFromWindow(leisureTime.time_window) + ''
          this.formLeisureTime.timeFrom.mm = (this.calculateMinuteFromWindow(leisureTime.time_window) + '').padStart(2, '0')
          this.formLeisureTime.timeTo.H = (this.calculateHourFromWindow(leisureTime.time_window + leisureTime.duration) % 24) + ''
          this.formLeisureTime.timeTo.mm = (this.calculateMinuteFromWindow(leisureTime.time_window + leisureTime.duration) + '').padStart(2, '0')
          this.formLeisureTime.note = leisureTime.note
          this.formLeisureTime.allDay = leisureTime.all_day
          this.editingId = leisureTime.id
          this.originalLeisureTime = this.populateToSave(this.formLeisureTime)
        } else {
          this.formLeisureTime = {
            id: null,
            timeFrom: {
              H: '',
              mm: ''
            },
            timeTo: {
              H: '',
              mm: ''
            },
            valid: null,
            note: '',
            allDay: false
          }
          this.editingId = false
        }
      },
      calculateHourFromWindow (window) {
        return Math.floor((window - 1) / 12)
      },
      calculateMinuteFromWindow (window) {
        return ((window - 1) % 12) * 5
      },
      calculateWindowFromTime (hours, minutes) {
        return (((hours * 12) + (minutes / 5)) + 1)
      },
      calculateWindowDurationFromTime (hoursFrom, minutesFrom, hoursTo, minutesTo) {
        // Use 0:00 like 24:00
        if ((hoursTo + '' + minutesTo) === '000') {
          hoursTo = 24
        }
        return (this.calculateWindowFromTime(hoursTo, minutesTo) - this.calculateWindowFromTime(hoursFrom, minutesFrom))
      },
      isTimeFilled: function (from, to) {
        return (from.H !== '' && from.mm !== '' && to.H !== '' && to.mm !== '')
      },
      isDurationPositive (from, to) {
        return (this.calculateWindowDurationFromTime(from.H, from.mm, to.H, to.mm) > 0)
      },
      tryPopulateFromForm () {
        if (this.possibleToSave === true) {
          if (this.editingId !== false) {
            this.updatedLeisureTime = this.populateToSave(this.formLeisureTime)
          } else {
            this.newLeisureTime = this.populateToSave(this.formLeisureTime)
            delete this.newLeisureTime.id
          }
        } else {
          this.updatedLeisureTime = {}
        }
      },
      populateToSave (formData) {
        let saveData = {}
        if (formData.allDay === false) {
          saveData.time_window = this.calculateWindowFromTime(formData.timeFrom.H, formData.timeFrom.mm)
          saveData.duration = this.calculateWindowDurationFromTime(formData.timeFrom.H, formData.timeFrom.mm, formData.timeTo.H, formData.timeTo.mm)
        } else {
          saveData.time_window = 1
          saveData.duration = 288
        }
        saveData.id = this.editingId
        saveData.valid = this.$moment(formData.valid).format('L')
        saveData.note = formData.note
        return saveData
      },
      submitFormUpdateLeisureTime () {
        this.putLeisureTime(this.updatedLeisureTime)
      },
      submitFormAddLeisureTime () {
        this.postLeisureTime(this.newLeisureTime, this.doctorId)
      }
    },
    watch: {
      'formLeisureTime.timeFrom' () {
        this.tryPopulateFromForm()
      },
      'formLeisureTime.allDay' () {
        this.tryPopulateFromForm()
      },
      'formLeisureTime.timeTo' () {
        this.tryPopulateFromForm()
      },
      'formLeisureTime.valid' () {
        this.tryPopulateFromForm()
      },
      'formLeisureTime.note' () {
        this.tryPopulateFromForm()
      },
      newLeisureTimeDone (val) {
        this.newLeisureTime = {}
        if (val === true) {
          this.getDoctorsLeisureTime(this.doctorId)
          this.newLeisureTimeDone = false
        }
      },
      deleteLeisureTimeDone (val) {
        if (val === true) {
          this.getDoctorsLeisureTime(this.doctorId)
          this.deleteLeisureTimeDone = false
        }
      },
      updatedLeisureTimeDone (val) {
        if (val === true) {
          this.$emit('leisure-time-updated')
          this.editingId = false
          this.updatedLeisureTime = {}
          this.getDoctorsLeisureTime(this.doctorId)
          this.updatedLeisureTimeDone = false
        }
      }
    },
    computed: {
      possibleToSave: function () {
        return ((this.isDurationPositive(this.formLeisureTime.timeFrom, this.formLeisureTime.timeTo) && this.isTimeFilled(this.formLeisureTime.timeFrom, this.formLeisureTime.timeTo)) || this.formLeisureTime.allDay === true)
      },
      formChanged: function () {
        return JSON.stringify(this.originalLeisureTime) !== JSON.stringify(this.updatedLeisureTime)
      }
    }
  }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>

</style>



// WEBPACK FOOTER //
// src/views/Calendar/modals/LeisureTime.vue?01bf50f2